import { type FC } from 'react';
import {
  WarningCircle
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconWarningCircleProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconWarningCircle: FC<UiIconWarningCircleProps> = (props) => {
  return (
    <UiIcon
      IconComponent={WarningCircle}
      {...props}
    />
  );
};
